import { InfoCircleOutlined } from "@ant-design/icons";
import { Col, Form, Row } from "antd";
import { InputCalendarioDate } from "components/input/InputCalendarioDate";
import { InputCalendarioRange } from "components/input/InputCalendarioRange";
import { InputNumberQtd } from "components/input/InputNumberQtd";
import { InputPercentual } from "components/input/InputPercentual";
import { SelectRota } from "components/select/SelectRota";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { RelatorioFilterProdutorTransportador } from "pages/relatorios/components/RelatorioFilterProdutorTransportador";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioParams } from "pages/relatorios/types/ApiRelatorioParams";

export function FilterBar() {
	const filter = useRelatorioStore((s) => s.filter);
	const applyFilter = useRelatorioStore((s) => s.applyFilter);

	const [formFiltroAvancado] = Form.useForm<ApiRelatorioParams>();

	const handleFilter = (formValues: ApiRelatorioParams): void => {
		applyFilter(formValues);
	};

	return (
		<Form layout="vertical" form={formFiltroAvancado} onFinish={handleFilter}>
			<Row gutter={[10, 10]}>
				<RelatorioFilterProdutorTransportador showProdutor={true} showTransportador={true} />

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterMesRef" label="Mês Ref">
						<InputCalendarioDate
							picker="month"
							format="MM/YYYY"
							placeholder="Mês Ref."
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterMesRef: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterData" label="Data da Coleta">
						<InputCalendarioRange
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterData: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterRotaIdpk" label="Rota">
						<SelectRota
							onChange={(_, rota) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterRota: rota,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin
						name="filterThresholdPct"
						label="Threshold (%)"
						tooltip={{
							title: (
								<>
									<p>Valor de corte para a diferença entre a quantidades de volume do produtor.</p>
									<p>Caso não informado, o valor de 20 é usado.</p>
								</>
							),
							icon: <InfoCircleOutlined />,
						}}
					>
						<InputPercentual
							placeholder="Threshold %"
							onChange={(e) => {
								const val = Number(e);
								useRelatorioStore.setState({
									filter: { ...filter, filterThresholdPct: Number.isFinite(val) ? val : undefined },
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin
						name="filterCompareDays"
						label="Dias comparação"
						tooltip={{
							title: (
								<>
									<p>Total de dias anteriores para ser usados de comparação em conjunto com o Threshold.</p>
									<p>Ex: Compare o dia atual com 5 dias atrás e verifique se esta acima/abaixo do Threshold.</p>
									<p>Caso não informado, será levado a média do mês atual para comparação.</p>
								</>
							),
							icon: <InfoCircleOutlined />,
						}}
					>
						<InputNumberQtd
							placeholder="Dias"
							onChange={(e) => {
								const val = Number(e);
								useRelatorioStore.setState({
									filter: { ...filter, filterCompareDays: Number.isFinite(val) ? val : undefined },
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>
			</Row>
		</Form>
	);
}
